<template>
  <div class="resut-main">
    <search-bar/>
    <el-table
      ref="searchResult"
      v-loading="listLoading"
      :key="tableKey"
      :data="result"
      :cell-style="cellStyle"
      :header-cell-style="cellStyle"
      fit
      highlight-current-row
      style="width: 960px;"
      row-key="id"
      @row-click="openDetails"
      :expand-row-keys="expandKeys"
      @expand-change="expandChange">
      <el-table-column label="编号" align="center" >
        <template slot-scope="scope">
          <span>{{ scope.row.sn }}</span>
        </template>
      </el-table-column>
      <el-table-column label="捐赠人" align="center" >
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="捐赠类型" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.type }}</span>
        </template>
      </el-table-column>
      <el-table-column label="捐赠数量" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.num }}</span>
        </template>
      </el-table-column>
      <el-table-column label="捐赠时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.state }}</span>
        </template>
      </el-table-column>
      <el-table-column label="接受人" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.donated }}</span>
        </template>
      </el-table-column>
      <el-table-column type="expand" label="详情">
        <template slot-scope="scope">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="接受人">
              <span>{{ scope.row.donated }}</span>
            </el-form-item>
            <el-form-item label="接受人电话">
              <span>{{ scope.row.donatedPhone }}</span>
            </el-form-item>
            <el-form-item label="接收人地址">
              <span>{{ scope.row.donatedAddress }}</span>
            </el-form-item>
            <el-form-item label="详情">
              <span>{{ scope.row.donatedSum }}</span>
            </el-form-item>
            <el-form-item label="备注">
              <span>{{ scope.row.remark }}</span>
            </el-form-item>
            <el-form-item v-if="Array.isArray(scope.row.detail)" label="流转信息：">
              <span></span>
            </el-form-item>
            <el-form-item v-for="d in scope.row.detail" v-bind:key="d.id" >
              <span>{{ d.date }} - {{ d.receiver }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size" @pagination="getList" />
    <foote />
  </div>
</template>

<script>
import Vue from 'vue'
import SearchBar from '@/components/Search'
import { search, interflow } from '@/api'
import Pagination from '@/components/Pagination'
import foote from './Footer'

export default {
  name: 'searchResult',
  components: { SearchBar, Pagination, foote },
  data () {
    return {
      expandKeys: [], /** 新增 **/
      tableKey: 0,
      listQuery: {
        page: 1,
        size: 10,
        keyword: this.$route.params.keyword
      },
      listLoading: false,
      result: [],
      total: 0
    }
  },
  methods: {
    getList () {
      this.listLoading = true
      search(this.listQuery).then(response => {
        if (response && response.data && response.data.success === true) {
          this.result = response.data.data.records
          this.total = response.data.data.total
          this.listLoading = false
        } else if (response && response.data && response.data.success === false) {
          this.listLoading = false
          this.$message({
            type: 'error',
            message: '查询失败'
          })
        }
      })
    },
    openDetails (row, event, column) {
      this.$refs.searchResult.toggleRowExpansion(row)
    },
    expandChange (row, expandedRows) {
      interflow(row.id).then(response => {
        if (response && response.data && response.data.success === true) {
          // console.log(response.data)
          row.detail = response.data.data
          this.result.forEach((val, index) => {
            if (val.id === row.id) {
              Vue.set(this.result, index, row)
            }
          })
        }
      })
    },
    cellStyle () {
      return 'background-color: #0d0d0d'
    }
  },
  created () {
    this.getList()
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route' (to, from) {
      this.listQuery.keyword = to.params.keyword
      this.listQuery.page = 1
      this.listQuery.size = 10
      this.getList()
    }
  }
}
</script>

<style type="less">
.resut-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  /*background-color: #000;*/
  .result {
    width: 1000px;
    /*.el-table td, .el-table, th.is-leaf {
      border-bottom: 1px solid #f00 !important;
    }*/
  }
}
.el-table td, .el-table th {
  border-bottom: 1px solid #333 !important;
}
.el-table__empty-block {
  background-color: #0d0d0d !important;
}
.pagination-container {
  background: #0d0d0d !important;
}
.el-pagination.is-background .el-pager li,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background-color: #313131 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ff7800 !important;
    color: #fff;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover{
  color: #ff7800 !important;
}
.el-pagination .el-input__inner {
  background-color: #333 !important;
  color: #fff !important;
  border: 0px !important;
}
.el-table::before {
  display: none;
}
/*.demo-table-expand {
  font-size: 0;
}*/
.demo-table-expand label {
  width: 90px !important;
  color: #99a9bf !important;
}
.demo-table-expand .el-form-item {
  margin-right: 0 !important;
  margin-bottom: 0 !important;
  width: 100% !important;
}
.demo-table-expand .el-form-item .el-form-item__label {
  line-height: 30px !important;
}
.demo-table-expand .el-form-item .el-form-item__content {
  line-height: 30px !important;
}
.el-form-item-l {
  width: 100% !important;
}
.resut-main .el-table__expanded-cell, .resut-main .el-table__expanded-cell:hover {
  background-color: #181818 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchResult.vue